module.exports = __webpack_public_path__ + "img/5.8256e63.svg";